module.exports = __webpack_public_path__ + "static/dekella_bident_of_thassa-e190a5238dfa8832cc0c5a842c73a104.jpg";